export default "__VITE_ASSET__gSoaLDve__"